import { noop } from 'lodash';
import { useEffect, useMemo, useState } from 'react';
import { sendError } from '../sentry';
import { getUrlParam } from '../utils/get-url-param';

function usePollContextData() {
  const pollContextToken = useMemo(() => getUrlParam('_pcid'), []);
  const [isLoading, setLoading] = useState(!!pollContextToken);
  const [variables, setVariables] = useState<Store | null>(null);

  const getVariables = async (token: string) => {
    let variables: Record<string, string> | null = null;
    try {
      variables = await fetch(new URL(token, window.APP_POLL_CONTEXT_URL)).then(
        res => res.json() as Promise<Record<string, string>>,
      );
    } catch (error) {
      sendError(new Error('Failed to fetch poll-context'), {
        severity: 'MAJOR',
        actualError: error,
      });
    }

    setVariables(variables);
    setLoading(false);
  };

  useEffect(() => {
    if (pollContextToken) getVariables(pollContextToken).catch(noop);
  }, []);

  return { variables, isLoading };
}

export default usePollContextData;
